// VEC-4137: los montos del presupuesto simple llegan como número (desde VEC-1994) o como string
// decimal desde la grilla. 0 es un monto válido: Validator.floatNunmber lo rechaza por falsy.
export const montoPresupuestoValido = (value) =>
    value !== null && value !== undefined && value !== '' &&
    Number.isFinite(Number(value)) && Number(value) >= 0;

export const validarMontoPresupuesto = (value) => {
    const valid = montoPresupuestoValido(value);
    return { valid, message: valid ? '' : 'Dato requerido' };
};
